<template>
  <b-modal id="view_notes_list_modal" ref="view_notes_list_modal" size="xl" scrollabl9e hide-footer no-close-on-esc
    no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="far fa-sticky-note"></i>
          <span v-if="service == 'sales_company'">COMPANY SALES NOTES</span>
          <span v-else-if="service == 'sales_worker'">WORKER SALES NOTES</span>
          <span v-else-if="service == 'service_company'">COMPANY SERVICE NOTES</span>
          <span v-else-if="service == 'service_worker'">WORKER SERVICE NOTES</span>

        </h1>
        <p id="mh-info">
          <span>List of
            <span v-if="type == 'total'">Total Notes</span>
            <span v-else-if="type == 'calls.total'">Total Calls</span>
            <span v-else-if="type == 'calls.connected.incoming'">Connected (In)</span>
            <span v-else-if="type == 'calls.connected.outgoing'">Connected (Out)</span>
            <span v-else-if="type == 'calls.connected.decision_maker'">Connected DM Calls</span>
            <span v-else-if="type == 'emails'">Emails</span>
            <span v-else-if="type == 'meetings.booked'">Meetings (Booked)</span>
            <span v-else-if="type == 'meetings.held'">Meetings (Held)</span>
            <span v-else-if="type == 'meetings.drop_in'">Meetings (Drop&nbsp;In's)</span>
            <span v-else-if="type == 'calls.connected.tax_discussed'">Tax (Discussed)</span>
            <span v-else-if="type == 'calls.connected.tax_sold'">Tax (Sold)</span>
          </span>
        </p>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <!--    <p><strong>Note On {{ $store.state.notes.type | capitalWords }}:</strong> {{ $store.state.notes.name }}</p>-->


    <loadingCube v-if="!stats_loaded" :loadingMessage="'NOTE STATS'"></loadingCube>

    <div v-else-if="note_stats_list.length > 0">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Call Note</th>
            <th style="width: 125px;">Date</th>
            <th style="width: 125px;">Type</th>
            <!-- <th>Voicemail Left</th> -->
            <!-- <th>Call Type</th> -->
            <!-- <th>Decision Maker Call</th> -->
            <!-- <th>Discussed Tax</th> -->
            <!-- <th>Sold Tax</th> -->
            <th>Company</th>
            <th>Note</th>
            <th>Note on</th>
            <th>Left by</th>
            <th>Note type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(note, index) in note_stats_list" :key="index">
            <td>{{ index + 1 }}</td>
            <td><span v-if="note.is_call">Yes</span><span v-else>No</span></td>
            <td>{{ note.created_at | formatDateTime }}</td>
            <td>{{note.type}} ({{ note.logs_notes_created_at | formatDateTime }})</td>
            <!-- <td>
              <span v-if="note.is_call">
                <span v-if="note.voicemail">Yes</span><span v-else>No</span>
              </span>
            </td> -->
            <!-- <td>
              <span v-if="note.is_call">
                {{ note.call_type }}
              </span>
            </td> -->
            <!-- <td>
              <span v-if="note.worker_id === null">
                <span v-if="note.decision_maker">Yes</span><span v-else>No</span>
              </span>
            </td> -->

            <!-- <td>
              <span v-if="note.worker_id !== null && note.is_call">
                <span v-if="note.discussed_tax">Yes</span><span v-else>No</span>
              </span>
            </td> -->
            <!-- <td>
              <span v-if="note.worker_id !== null && note.is_call && note.discussed_tax">
                <span v-if="note.sold_tax">Yes</span><span v-else>No</span>
              </span>
            </td> -->
            <td>{{ note.company_name }}</td>
            <td>
              <div>
                {{ note.expanded || note.note.length <= 50 ? note.note : note.note.slice(0, 50) + '...' }}

                <button v-if="note.note.length > 50" @click="toggleText(note)" class="btn btn-outline-success btn-sm btn-show-more">
                  {{ note.expanded ? 'Show Less' : 'Show More' }}
                </button>
              </div>
            </td>
            <td>{{ note.belongs_to.person ? note.belongs_to.person.first_name : '' }} {{ note.belongs_to.person ? note.belongs_to.person.surname : '' }}</td>
            <td>{{ note.note_log_by.first_name }} {{ note.note_log_by.surname }}</td>
            <td>{{ note.note_type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>No data</div>

    <div class="row mt-4">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import loadingCube from "loaders/record_loader";
export default {
  name: "view_notes_list",
  components: {
    loadingCube,
  },
  data() {
    return {
      stats_loaded: false,
      note: {
        note_logs: {},
        note_log_by: {},
        belongs_to: {},
        note_type: {},
      },
      service: {},
      type: {},
      note_stats_list: {},
    }
  },
  mounted() {
    this.get_stats().then(() => this.stats_loaded = true)
  },
  methods: {
    get_stats() {
      return axios.get(this.crmApiPath + 'crm/reports/note_stats_data/' + this.$store.state.notes.id).then(stats => {
        console.log(stats.data.stats_results);
        this.service = stats.data.service
        this.type = stats.data.type
        this.note_stats_list = stats.data.stats_results
      });
    },
    hideModal() {
      this.$refs.view_notes_list_modal.hide();
      this.$store.commit('HIDE_NOTE_MODALS');
    },
    toggleText(note) {
      this.$set(note, 'expanded', !note.expanded);
    },
  }
}
</script>

<style scoped lang="scss">
.btn-show-more {
    height: 18px;
    padding: 1px;
}
pre {
  font-family: $font-family-paragraph;
  font-size: 0.8rem;
}
</style>
